<template>
  <!-- Modal -->
  <div
    class="modal fade"
    id="UpdateMemberJoinDate"
    tabindex="-1"
    role="dialog"
    aria-labelledby="UpdateMemberJoinDateLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="d-flex justify-content-between p-3">
          <h5 class="fs-18 fw-700 txt-grey-900" id="modalUpdateDiseaseLabel">
            {{$t('multidisciplinary_board.lbl_sequence')}}
          </h5>
          <button
            type="button"
            class="close bg-white border-0"
            data-dismiss="modal"
            aria-label="Close"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13.4099 12.0002L19.7099 5.71019C19.8982 5.52188 20.004 5.26649 20.004 5.00019C20.004 4.73388 19.8982 4.47849 19.7099 4.29019C19.5216 4.10188 19.2662 3.99609 18.9999 3.99609C18.7336 3.99609 18.4782 4.10188 18.2899 4.29019L11.9999 10.5902L5.70994 4.29019C5.52164 4.10188 5.26624 3.99609 4.99994 3.99609C4.73364 3.99609 4.47824 4.10188 4.28994 4.29019C4.10164 4.47849 3.99585 4.73388 3.99585 5.00019C3.99585 5.26649 4.10164 5.52188 4.28994 5.71019L10.5899 12.0002L4.28994 18.2902C4.19621 18.3831 4.12182 18.4937 4.07105 18.6156C4.02028 18.7375 3.99414 18.8682 3.99414 19.0002C3.99414 19.1322 4.02028 19.2629 4.07105 19.3848C4.12182 19.5066 4.19621 19.6172 4.28994 19.7102C4.3829 19.8039 4.4935 19.8783 4.61536 19.9291C4.73722 19.9798 4.86793 20.006 4.99994 20.006C5.13195 20.006 5.26266 19.9798 5.38452 19.9291C5.50638 19.8783 5.61698 19.8039 5.70994 19.7102L11.9999 13.4102L18.2899 19.7102C18.3829 19.8039 18.4935 19.8783 18.6154 19.9291C18.7372 19.9798 18.8679 20.006 18.9999 20.006C19.132 20.006 19.2627 19.9798 19.3845 19.9291C19.5064 19.8783 19.617 19.8039 19.7099 19.7102C19.8037 19.6172 19.8781 19.5066 19.9288 19.3848C19.9796 19.2629 20.0057 19.1322 20.0057 19.0002C20.0057 18.8682 19.9796 18.7375 19.9288 18.6156C19.8781 18.4937 19.8037 18.3831 19.7099 18.2902L13.4099 12.0002Z" fill="#475467"/>
</svg>

          </button>
        </div>
        <div class="modal-body">
            <div class="mb-3 d-flex align-items-center" @click="type = 1">
                <input v-model="type" :value="1" type="radio" name="joinType" id="joinType1" class="mr-2">
                <label for="joinType1" class="fs-16 txt-grey-900 cursor-pointer mr-2">{{$t('multidisciplinary_board.lbl_onetime')}}</label>
                <input type="date" class="form-control w-50 fs-16 txt-grey-900 radius-10 bg-white border" v-model="date">
            </div>
            <div class="mb-3 d-flex align-items-center">
                <input v-model="type" :value="2" type="radio" name="joinType" id="joinType2" class="mr-2">
                <label for="joinType2" class="fs-16 txt-grey-900 cursor-pointer">{{$t('multidisciplinary_board.lbl_routine_join')}}</label>
            </div>
          <div class="text-center">
            <button type="button" class="btn bg-pri text-white px-4" @click="updateMdtMemberJoinDate">{{$t('multidisciplinary_board.btn_save')}}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UpdateMemberJoinDate',
  props: ['member'],
  data () {
    return {
      date: '',
      type: 1
    }
  },
  watch: {
    member (m) {
      if (m) {
        if (m.join_date) {
          this.date = m.join_date
          this.type = 1
        } else {
          this.date = ''
          this.type = 2
        }
      } else {
        this.date = ''
        this.type = 1
      }
    },
    type (t) {
      if (t === 2) {
        this.date = ''
      }
    }
  },
  methods: {
    async updateMdtMemberJoinDate () {
      let self = this
      let params = {
        date: this.date
      }
      await this.$rf.getRequest('DoctorRequest').updateMdtMemberJoinDate(this.member.id, params).then((r) => {
        self.$emit('refresh')
      })
    }
  }
}
</script>

<style scoped>
</style>